import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import {Box, DatePicker, DropdownSelector2, IconButton, ImportButton, CenteredSpin} from '../../../ui'
import style from './style.m.less'
import { Import } from '../../../../assets/icons'
import { Filters } from '../GenerationAttributes'
import { Moment } from 'moment'
import FileSaver from 'file-saver'
import { message, Spin } from 'antd'
import { GOListItem } from '../../types'
import InputOnlyNumber from '../../../ui/InputOnlyNumber/InputOnlyNumber'
import request from "../../../../services/request";
import moment from 'moment'

interface IControlsBlock {
    onChange: (value: string) => void
    onChangeFilters: Dispatch<SetStateAction<Filters>>
    currentOption: string
    options: { label: string; id: string }[]
    goList: GOListItem[]
    filters: any
}

const ControlsBlock: FC<IControlsBlock> = ({
    options,
    currentOption,
    goList,
    onChange,
    onChangeFilters,
    filters
}) => {
    const isOverdue = currentOption === 'Истек срок действия'
    const isBlocked = currentOption === 'Заблокированные/неоплаченные'
    const filterName = isOverdue ? 'expires_at' : isBlocked ? 'blocked_at' : 'registered_at'

    const [isDownloading, setIsDownloading] = useState(false)

    useEffect(() => {
        onChangeFilters((filters: Filters) => {
            const newFilters = { ...filters }
            // delete newFilters['']
            // delete newFilters['']
            // delete newFilters['']
            return {
                ...newFilters,
            }
        })
    }, [currentOption])

    const handleDownload = async () => {
        try {
            setIsDownloading(true)

            const url = `/api/generation_attributes/v1/gas/ga/list`
            const getParams = {
                params: {
                    download: true,
                    unloading_date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    ...filters
                },
                responseType: 'blob'
            }

            const body = await request.get(url, getParams)
            const status = body?.status

            if (status === 200) {
                const fileName = body?.headers.filename
                const bodyBlob = new Blob([body?.data], {
                    type: 'application/octet-stream',
                })

                FileSaver.saveAs(bodyBlob, fileName)
            }
        } catch (error: any) {
            message.error(error.err_message ?? error)
        } finally {
            setIsDownloading(false)
        }
    }

    return (
        <>
            <div className={style.controlsBlock}>
                <div className={style.controlsBlockInner}>
                    <div className={style.inputsRow}>
                        <div className={style.selectorWrapper}>
                            <div className={style.selector}>
                                {options?.map(({ id, label }) => (
                                    <Box direction="row" key={id}>
                                        <div
                                            className={
                                                currentOption === label
                                                    ? style.agToolSelected
                                                    : style.agTool
                                            }
                                            onClick={() => onChange(label)}
                                        >
                                            {label}
                                        </div>
                                        <div className={style.spaceBar}></div>
                                    </Box>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={style.importButtonContrainer}>
                        <Spin spinning={isDownloading}>
                            <IconButton
                                icon={<Import />}
                                customIconStyle={{ marginRight: '8px', marginTop: '3px' }}
                                onClick={handleDownload}
                            >
                                Выгрузить данные
                            </IconButton>
                        </Spin>
                    </div>
                </div>
                {isDownloading && <CenteredSpin />}
                <div className={style.filters}>
                    <div className={style.leftGapBlock}>
                        <div>Период выработки</div>
                        <div className={style.inputBlock}>
                            <DatePicker
                                customStyle={{ width: '100%' }}
                                onChange={(value: Moment) => {
                                    onChangeFilters((filters: Filters) => ({
                                        ...filters,
                                        period: value?.format('YYYY-MM-DD'),
                                    }))
                                }}
                                defaultValue={filters.period ? moment(filters.period) : null}
                            />
                        </div>
                    </div>
                    <div className={style.leftGapBlock}>
                        <div>Объем, кВт*ч</div>
                        <div className={style.inputBlock}>
                            <InputOnlyNumber
                                style={{ width: '100%', borderRadius: '8px' }}
                                className={style.inputBlockInput}
                                placeholder={'Введите объем'}
                                value={filters.volume || null}
                                onChange={(volume: any) =>
                                    onChangeFilters((filters: Filters) => ({
                                        ...filters,
                                        volume,
                                    }))
                                }
                            />
                        </div>
                    </div>
                    <div className={style.leftGapBlock}>
                        <div>ЗГО</div>
                        <div className={style.inputBlock}>
                            <DropdownSelector2
                                customStyle={{ width: '100%' }}
                                options={(goList || []).map((item) => ({
                                    text: item.name,
                                    value: item.generator_id,
                                    id: item.generator_id,
                                }))}
                                placeholder={'Все'}
                                allowClear
                                onChange={(value) =>
                                    onChangeFilters((filters: Filters) => ({
                                        ...filters,
                                        generator_id: value,
                                    }))
                                }
                                value={filters.generator_id || null}
                            />
                        </div>
                    </div>
                    <div className={style.leftGapBlock}>
                        <div>
                            {isOverdue
                                ? 'Дата окончания срока действия'
                                : isBlocked
                                ? 'Дата блокировки'
                                : 'Дата занесения в реестр'}
                        </div>
                        <div className={style.inputBlock}>
                            <DatePicker
                                key={isOverdue ? '111111' : isBlocked ? '222222' : '333333'}
                                customStyle={{ width: '100%' }}
                                onChange={(value: Moment) => {
                                    onChangeFilters((filters: Filters) => ({
                                        ...filters,
                                        [filterName]: value?.format('YYYY-MM-DD'),
                                    }))
                                }}
                                defaultValue={filters[filterName] ? moment(filters[filterName]) : null}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ControlsBlock
